import {mainColor, UNIT} from '../../constants'
import {createStyles} from '@material-ui/core'

export const styles = createStyles ({
  root: {
    overflowX: 'auto',
    padding: 1.25 * UNIT
  },
  progress: {
    textAlign: 'center',
    color: mainColor.secondaryColor,
    margin: 5 * UNIT
  },
  button: {
    backgroundColor: mainColor.colorWhite
  },
  paper: {
    width: '100%',
    height: UNIT * 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconFile: {
    fontSize: UNIT * 8,
    color: 'gray',
    margin: UNIT * 1.25
  },
  svg: { padding: UNIT * 0.625 },
});
